import React, { useEffect, useState, useCallback } from 'react';
import { Link } from 'react-router-dom';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import ConstructionCard from '../ConstructionCard/ConstructonCard';
import './PropertyCarousel.css';
import axios from 'axios';

const PropertyCarousel = ({ filterType, pageTitle }) => {
  const [properties, setProperties] = useState([]);
  const [loading, setLoading] = useState(true);
  const [slidesToShow, setSlidesToShow] = useState(4);

  const fetchProjects = useCallback(async () => {
    try {
      setLoading(true);
      const res = await axios.get(`https://gladious-constructions.onrender.com/api/properties?projectType=${filterType}`);
      const allProperties = res.data.data || res.data;
      setProperties(allProperties);
    } catch (err) {
      console.log('Error fetching projects: ' + err.message);
    } finally {
      setLoading(false);
    }
  }, [filterType]);

  useEffect(() => {
    fetchProjects();
  }, [fetchProjects]);

  const getLinkDestination = () => {
    switch(filterType) {
      case 'for-sale': return '/for-sale';
      case 'for-rent': return '/for-rent';
      case 'upcoming': return '/upcoming-projects';
      default: return '/';
    }
  };

  const SampleNextArrow = ({ onClick }) => (
    <div className="custom-arrow next carousel-button" onClick={onClick}>
      <img src="/images/right.png" alt="" />
    </div>
  );

  const SamplePrevArrow = ({ onClick }) => (
    <div className="custom-arrow prev carousel-button" onClick={onClick}>
      <img src="/images/left.png" alt="" />
    </div>
  );

useEffect(() => {
  const updateSlidesToShow = () => {
    const width = window.innerWidth;
    if (width < 480) setSlidesToShow(1);
    else if (width < 768) setSlidesToShow(2);
    else if (width < 1024) setSlidesToShow(3);
    else setSlidesToShow(4);
  };

  updateSlidesToShow();
  window.addEventListener('resize', updateSlidesToShow);
  return () => window.removeEventListener('resize', updateSlidesToShow);
}, []);


  const settings = {
    dots: false,
    infinite: properties.length > 4,
    speed: 500,
    slidesToShow,
    slidesToScroll: 1,
    autoplay: properties.length > 4,
    autoplaySpeed: 3000,
    pauseOnHover: true,
    arrows: true,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: properties.length > 3,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: properties.length > 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: properties.length > 1,
        },
      },
    ],
  };

  return (
    <div className="property-carousel-container">
      <div className="carousel-header">
        <h2 className="carousel-title">{pageTitle}</h2>
      </div>

      {loading ? (
        <div className='property-loading-logo'>
  <img src="/images/logo.png" alt="loading" />
        </div>
      ) : properties.length === 0 ? (
        <div className="no-properties-message">No property available</div>
      ) : (
        <div className="slider-container">
          <Slider {...settings}>
            {properties.map((item) => (
              <div key={item._id} className="carousel-slide">
                <div className="property-card">
                  <ConstructionCard
                    data={{
                      id: item._id,
                      images: item.images,
                      category: item.category,
                      area: item.area,
                      title: item.title,
                      description: item.description,
                      price: item.price,
                      location: item.location,
                      bedrooms: item.bedrooms || 0,
                      bathrooms: item.bathrooms || 0,
                      email: item.email,
                      phone: item.phone,
                    }}
                  />
                </div>
              </div>
            ))}
          </Slider>
        </div>
      )}

      {properties.length !== 0 && (
      <div className="load-more-btn-container">
              <Link to={getLinkDestination()} className="load-more-btn cursor-hover">
          LOAD MORE
        </Link>
        </div>
)}
    </div>
  );
};

export default PropertyCarousel;
